import * as React from 'react';
import icon from '../../assets/img/flags/maine.svg';

export const Maine = (props) => <img src={icon} height={props.height || 100} alt="Flag" />;
